import { put, takeEvery } from 'redux-saga/effects';

import { EMIT_TYPING_INDICATOR } from './druid/actions/emitTypingIndicator';
import postActivity from './druid/actions/postActivity';
import whileConnected from '/druid/effects/whileConnected';

function* postTypingActivity() {
  yield put(
    postActivity({
      type: 'typing'
    })
  );
}

function* emitTypingActivityToPostActivity() {
  yield takeEvery(({ type }) => type === EMIT_TYPING_INDICATOR, postTypingActivity);
}

export default function* emitTypingActivityToPostActivitySaga() {
  yield whileConnected(emitTypingActivityToPostActivity);
}
